/**
 * Created by Ning Jiang on 10/12/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Timeline, TimelineLite} from "gsap";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneParsedInitData} from "../../server/data/TombstoneParsedInitData";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {TombstoneBonusSymbolWPView} from "./TombstoneBonusSymbolWPView";

export class TombstoneBonusSymbolWPController extends WinPresentationController {

    private _mainTimeline:TimelineLite | null;
    private _introTimeline:TimelineLite;
    private _introDisplayedProgress:number;
    private _respinTriggered:boolean;
    private _bonusPositions:number[];
    private _isRestoreRespin:boolean;
    private _bonusSpinsLeft:number;

    private _view:TombstoneBonusSymbolWPView;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "BonusSymbol", skippable : true});
        this._view = new TombstoneBonusSymbolWPView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.parseInitData(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_START, (event:GameEvent) => this.onGameStart());
    }

    private parseInitData(data:TombstoneParsedInitData):void {
        this._isRestoreRespin = data.isRestoreState && data.nextMode === GameMode.RESPIN;
    }

    private onGameStart():void {
        if(this._isRestoreRespin) {
            this.playRSSound();
        }
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        this._respinTriggered = data.bonusTriggeredThisSpin;
        this._bonusPositions = data.bonusPositions;
        this._bonusSpinsLeft = data.bonusSpinsLeft;
        if(this._respinTriggered && (this._bonusPositions[0] === -1 || this._bonusPositions[4] === -1)) {
            debugger;
            throw new Error("TombstoneBonusSymbolWPController.parseFeatureGameData(): bonusPositions data doesn't match the feature.")
        }
    }

    protected hasWin():boolean {
        return this._respinTriggered;
    }

    protected startWinPresentation():void {
        this.setIntroTimeline();

        const timeline:TimelineLite = new TimelineLite({paused : true});
        timeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.instance.BONUS_WIN), 0);
        timeline.add(this.getBonusSymbolAnimation(0, false), 0);
        timeline.add(this.getBonusSymbolAnimation(4, false), 0);
        timeline.add(() => {
            this._introTimeline.timeScale(1);
            this._introTimeline.restart();
        });
        timeline.add(() => this.finish(), `+=${this._introTimeline.totalDuration()}`);
        this._mainTimeline = timeline;
        this._mainTimeline.play();
    }

    private setIntroTimeline():void {
        if(!this._introTimeline) {
            const introTimeline:TimelineLite = new TimelineLite({paused : true});
            introTimeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.instance.JUSTICE_INTRO));
            this._view.addIntroToTimeline(introTimeline);
            introTimeline.add(() => this.playRSSound(), "displayed");
            this._introTimeline = introTimeline;
            this._introDisplayedProgress = this._introTimeline.getLabelTime("displayed") / this._introTimeline.duration();
        }
    }

    private playRSSound():void {
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.playAmbience(TombstoneSoundConfig.instance.JUSTICE_AMBIANCE);
        SlotGame.sound.fadeAmbience(1, 0);
    }

    private getBonusSymbolAnimation(reelId:number, isAbort:boolean):Timeline | null {
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, this._bonusPositions[reelId]);
        if(symbol == null) {
            debugger;
            return null;
        }

        symbol.parent.addChild(symbol);
        return symbol.changeState({
            state : GameConfig.instance.SYMBOL_STATES.win,
            setStack : true,
            fadeInDuration : isAbort ? 0 : 0.1,
            frames : isAbort ? [-1, -1] : [0]
        })!;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._mainTimeline) {
            if(this._mainTimeline.isActive()) {
                this._mainTimeline.pause();
                this._mainTimeline.kill();
            }
            this._mainTimeline = null;
        }
        if(isAborted) {
            this.getBonusSymbolAnimation(0, true);
            this.getBonusSymbolAnimation(4, true);

            this.setIntroTimeline();
            if(this._introTimeline.progress() === 1) {
                this._introTimeline.restart();
            }
            if(this._introTimeline.progress() <= this._introDisplayedProgress) {
                this._introTimeline.timeScale(3).progress(this._introDisplayedProgress).play();
            } else {
                this._introTimeline.timeScale(3).play();
            }
        }

        SlotGame.keypad.setZeroBetSpinCounter(this._bonusSpinsLeft);
    }

    protected resetFeature():void {
        this._isRestoreRespin = false;
    }
}